/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Vape = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Vape"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#CE349A"
        d="M4.465 13.078c.774-.485.868-.919.868-1.078s-.094-.591-.863-1.075a2 2 0 0 1-.106-.07l-.017-.011C2.89 9.784 2 8.262 2 6.584c0-1.682.892-3.206 2.355-4.267a1.667 1.667 0 0 1 1.956 2.7c-.758.55-.978 1.137-.978 1.566 0 .422.212.996.938 1.538 1.407.894 2.396 2.252 2.396 3.879s-.989 2.985-2.396 3.879c-.726.541-.938 1.116-.938 1.538 0 .43.22 1.017.978 1.567a1.667 1.667 0 1 1-1.956 2.699C2.892 20.622 2 19.098 2 17.417c0-1.675.885-3.194 2.338-4.254a2 2 0 0 1 .127-.085"
      />
      <path
        fill="#CE349A"
        d="M11.131 13.078c.775-.485.869-.919.869-1.078s-.094-.591-.864-1.075a2 2 0 0 1-.106-.07l-.016-.011c-1.459-1.06-2.347-2.582-2.347-4.26 0-1.682.891-3.206 2.355-4.267a1.667 1.667 0 0 1 1.956 2.7C12.22 5.566 12 6.153 12 6.582c0 .422.211.996.937 1.538 1.408.894 2.396 2.252 2.396 3.879s-.988 2.985-2.395 3.879c-.726.541-.938 1.116-.938 1.538 0 .43.22 1.017.978 1.567a1.667 1.667 0 1 1-1.956 2.699c-1.464-1.061-2.355-2.585-2.355-4.266 0-1.675.884-3.194 2.337-4.254a2 2 0 0 1 .127-.085m6.667.001c.774-.485.869-.919.869-1.078s-.094-.591-.864-1.075a2 2 0 0 1-.106-.07l-.016-.011c-1.46-1.06-2.348-2.582-2.348-4.26 0-1.682.892-3.206 2.356-4.267a1.667 1.667 0 0 1 1.956 2.7c-.759.55-.978 1.137-.978 1.566 0 .422.211.996.937 1.538C21.011 9.015 22 10.373 22 12s-.988 2.985-2.395 3.879c-.727.541-.938 1.116-.938 1.538 0 .43.219 1.017.978 1.567a1.667 1.667 0 1 1-1.956 2.699c-1.464-1.061-2.356-2.585-2.356-4.266 0-1.675.885-3.194 2.338-4.254a2 2 0 0 1 .127-.085"
      />
    </g>
  </svg>
);

export const VapeIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'vape-icon'}
      icon={Vape}
      {...props}
      size={size}
    />
  );
};
